import { getThunkAndSlice } from "@src/store/getThunkAndSlice";

const initialState: Array<string> = [];

interface StatesResponse {
	states: Array<string>;
}
const countryCode = "US";

export const { thunk: fetchEventStates, slice: eventStatesSlice } = getThunkAndSlice<
	Record<string, never>,
	StatesResponse,
	Array<string>
>({
	initialState,
	path: `/api/events/filter/states/${countryCode}`,
	onAfterRequest: async (data: StatesResponse | Array<string>) => {
		if (Array.isArray(data)) return data;
		return data.states ?? [];
	},
});

export default eventStatesSlice.reducer;
